// extracted by mini-css-extract-plugin
module.exports = {"loading-indicator":"LoadingIndicator_loading-indicator__118KB","spin":"LoadingIndicator_spin__IVTHK"};